<template>
  <div class="editable-content">
    <template v-if="isEditMode">
      <input
        ref="input"
        v-model.trim="newValue"
        :size="displayValue.length"
        type="text">
      <div class="editable-content__actions">
        <oie-base-action theme="flat" confrim @click="confrim">
          <oie-base-icon icon="checkmark" size="xs"></oie-base-icon>
        </oie-base-action>
        <oie-base-action theme="flat" @click="close">
          <oie-base-icon icon="close" size="xs"></oie-base-icon>
        </oie-base-action>
      </div>
    </template>
    <template v-else>
      <span class="editable-content__display-value">{{ displayValue }}</span>
      <div v-if="displayValue && displayValue !== '-' && !displayValue.includes('*')" class="editable-content__actions">
        <oie-base-action theme="flat" @click="edit">
          <oie-base-icon icon="edit" size="xs"></oie-base-icon>
        </oie-base-action>
        <oie-base-action theme="flat" @click="$emit('delete')">
          <oie-base-icon icon="trash-can" size="xs"></oie-base-icon>
        </oie-base-action>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    displayValue: { type: String, default: '' }
  },
  data() {
    return {
      isEditMode: false,
      newValue: ''
    }
  },
  methods: {
    async edit() {
      this.newValue = this.displayValue
      this.isEditMode = true
      await this.$nextTick()
      this.$refs['input'].focus()
    },
    close() {
      this.newValue = ''
      this.isEditMode = false
    },
    confrim() {
      if(this.displayValue !== this.newValue) {
        this.$emit('change', this.newValue)
        this.close()
      } else {
        this.close()
      }
    }
  }

}
</script>

<style lang="scss">
.editable-content {
  display: flex;
  gap: measure(eighth);
}

.editable-content__actions {
  margin-left: auto;
  display: flex;
}

.editable-content__actions > button {
  padding: 5px; // todo: fix generix solution for only icon buttons in base-action
}
</style>
